const colorTokens = {
  neutral: {
    100: 'var(--color-neutral-100)',
    200: 'var(--color-neutral-200)',
    300: 'var(--color-neutral-300)',
    400: 'var(--color-neutral-400)',
    500: 'var(--color-neutral-500)',
    600: 'var(--color-neutral-600)',
    700: 'var(--color-neutral-700)',
    800: 'var(--color-neutral-800)',
    900: 'var(--color-neutral-900)',
    1000: 'var(--color-neutral-1000)',
  },
  brand: {
    white: 'var(--color-brand-white)',
    'grey-light': 'var(--color-brand-grey-light)',
    'indian-red': 'var(--color-brand-indian-red)',
    'iriggo-purple': 'var(--color-brand-iriggo-purple)',
    mint: 'var(--color-brand-mint)',
    'taskonio-green': 'var(--color-brand-taskonio-green)',
    'green-forest': 'var(--color-brand-green-forest)',
    'grey-dark': 'var(--color-brand-grey-dark)',
    black: 'var(--color-brand-black)',
  },
  taskonioGreen: {
    100: 'var(--color-taskonioGreen-100)',
    200: 'var(--color-taskonioGreen-200)',
    300: 'var(--color-taskonioGreen-300)',
    400: 'var(--color-taskonioGreen-400)',
    500: 'var(--color-taskonioGreen-500)',
    600: 'var(--color-taskonioGreen-600)',
    700: 'var(--color-taskonioGreen-700)',
    800: 'var(--color-taskonioGreen-800)',
    900: 'var(--color-taskonioGreen-900)',
    1000: 'var(--color-taskonioGreen-1000)',
  },
  blue: {
    100: 'var(--color-blue-100)',
    200: 'var(--color-blue-200)',
    300: 'var(--color-blue-300)',
    400: 'var(--color-blue-400)',
    500: 'var(--color-blue-500)',
    600: 'var(--color-blue-600)',
    700: 'var(--color-blue-700)',
    800: 'var(--color-blue-800)',
    900: 'var(--color-blue-900)',
    1000: 'var(--color-blue-1000)',
  },
  green: {
    100: 'var(--color-green-100)',
    200: 'var(--color-green-200)',
    300: 'var(--color-green-300)',
    400: 'var(--color-green-400)',
    500: 'var(--color-green-500)',
    600: 'var(--color-green-600)',
    700: 'var(--color-green-700)',
    800: 'var(--color-green-800)',
    900: 'var(--color-green-900)',
    1000: 'var(--color-green-1000)',
  },
  yellow: {
    100: 'var(--color-yellow-100)',
    200: 'var(--color-yellow-200)',
    300: 'var(--color-yellow-300)',
    400: 'var(--color-yellow-400)',
    500: 'var(--color-yellow-500)',
    600: 'var(--color-yellow-600)',
    700: 'var(--color-yellow-700)',
    800: 'var(--color-yellow-800)',
    900: 'var(--color-yellow-900)',
    1000: 'var(--color-yellow-1000)',
  },
  orange: {
    100: 'var(--color-orange-100)',
    200: 'var(--color-orange-200)',
    300: 'var(--color-orange-300)',
    400: 'var(--color-orange-400)',
    500: 'var(--color-orange-500)',
    600: 'var(--color-orange-600)',
    700: 'var(--color-orange-700)',
    800: 'var(--color-orange-800)',
    900: 'var(--color-orange-900)',
    1000: 'var(--color-orange-1000)',
  },
  red: {
    100: 'var(--color-red-100)',
    200: 'var(--color-red-200)',
    300: 'var(--color-red-300)',
    400: 'var(--color-red-400)',
    500: 'var(--color-red-500)',
    600: 'var(--color-red-600)',
    700: 'var(--color-red-700)',
    800: 'var(--color-red-800)',
    900: 'var(--color-red-900)',
    1000: 'var(--color-red-1000)',
  },
  purple: {
    100: 'var(--color-purple-100)',
    200: 'var(--color-purple-200)',
    300: 'var(--color-purple-300)',
    400: 'var(--color-purple-400)',
    500: 'var(--color-purple-500)',
    600: 'var(--color-purple-600)',
    700: 'var(--color-purple-700)',
    800: 'var(--color-purple-800)',
    900: 'var(--color-purple-900)',
    1000: 'var(--color-purple-1000)',
  },
};

export const lightColors = {
  neutral: {
    100: '#fafbfd',
    200: '#f6f7fb',
    300: '#ecedf5',
    400: '#e4e6ef',
    500: '#dee0eb',
    600: '#d5d7e1',
    700: '#bdbfcd',
    800: '#979cb0',
    900: '#707792',
    1000: '#313237',
  },
  brand: {
    white: '#ffffff',
    'grey-light': '#f6f7fb',
    'indian-red': '#ef4a63',
    'iriggo-purple': '#9747ff',
    mint: '#ade0d7',
    'taskonio-green': '#08cf65',
    'green-forest': '#1b4349',
    'grey-dark': '#313327',
    black: '#000000',
  },
  taskonioGreen: {
    100: '#e6ffed',
    200: '#adffc9',
    300: '#7ff5aa',
    400: '#54e88f',
    500: '#2cdb78',
    600: '#08cf65',
    700: '#00a854',
    800: '#008245',
    900: '#005c34',
    1000: '#003620',
  },
  blue: {
    100: '#e9f2ff',
    200: '#cce0ff',
    300: '#85b8ff',
    400: '#579DFF',
    500: '#388BFF',
    600: '#1D7AFC',
    700: '#0C66E4',
    800: '#0055CC',
    900: '#09326C',
    1000: '#082145',
  },
  green: {
    100: '#DFFCF0',
    200: '#BAF3DB',
    300: '#BAF3DB',
    400: '#4BCE97',
    500: '#2ABB7F',
    600: '#22A06B',
    700: '#1F845A',
    800: '#216E4E',
    900: '#164B35',
    1000: '#133527',
  },
  yellow: {
    100: '#FFF7D6',
    200: '#F8E6A0',
    300: '#F5CD47',
    400: '#E2B203',
    500: '#CF9F02',
    600: '#B38600',
    700: '#946F00',
    800: '#7F5F01',
    900: '#533F04',
    1000: '#533F04',
  },
  orange: {
    100: '#FFF4E5',
    200: '#FFE2BD',
    300: '#FEC57B',
    400: '#FAA53D',
    500: '#F18D13',
    600: '#D97008',
    700: '#B65C02',
    800: '#974F0C',
    900: '#5F3811',
    1000: '#43290F',
  },
  red: {
    100: '#FFEDEB',
    200: '#FFD2CC',
    300: '#FF9C8F',
    400: '#F87462',
    500: '#EF5C48',
    600: '#E34935',
    700: '#CA3521',
    800: '#AE2A19',
    900: '#601E16',
    1000: '#391813',
  },
  purple: {
    100: '#F9F0FF',
    200: '#EFDBFF',
    300: '#D3ADF7',
    400: '#B37FEB',
    500: '#9254DE',
    600: '#722ED1',
    700: '#531DAB',
    800: '#391085',
    900: '#22075E',
    1000: '#120338',
  },
};

export const darkColors = {
  neutral: {
    100: '#13171b',
    200: '#1b1f25',
    300: '#282d35',
    400: '#323841',
    500: '#3d444e',
    600: '#48505b',
    700: '#636d7c',
    800: '#8b95a5',
    900: '#b0b8c5',
    1000: '#ffffff',
  },
  brand: {
    white: '#0e1114',
    'grey-light': '#1b1f25',
    'indian-red': '#ef4a63',
    'iriggo-purple': '#9747ff',
    mint: '#2a5c53',
    'taskonio-green': '#08cf65',
    'green-forest': '#ade0d7',
    'grey-dark': '#e8e9eb',
    black: '#ffffff',
  },
  taskonioGreen: {
    100: '#0a2614',
    200: '#0e3a1e',
    300: '#145229',
    400: '#1a6b36',
    500: '#219e4e',
    600: '#08cf65',
    700: '#3ddb85',
    800: '#7ff5aa',
    900: '#adffc9',
    1000: '#e6ffed',
  },
  blue: {
    100: '#082145',
    200: '#09326C',
    300: '#0055CC',
    400: '#0C66E4',
    500: '#1D7AFC',
    600: '#388BFF',
    700: '#579DFF',
    800: '#85b8ff',
    900: '#cce0ff',
    1000: '#e9f2ff',
  },
  green: {
    100: '#133527',
    200: '#164B35',
    300: '#164B35',
    400: '#1F845A',
    500: '#22A06B',
    600: '#2ABB7F',
    700: '#4BCE97',
    800: '#BAF3DB',
    900: '#BAF3DB',
    1000: '#DFFCF0',
  },
  yellow: {
    100: '#533F04',
    200: '#7F5F01',
    300: '#946F00',
    400: '#B38600',
    500: '#CF9F02',
    600: '#E2B203',
    700: '#F5CD47',
    800: '#F8E6A0',
    900: '#FFF7D6',
    1000: '#FFF7D6',
  },
  orange: {
    100: '#43290F',
    200: '#5F3811',
    300: '#974F0C',
    400: '#B65C02',
    500: '#D97008',
    600: '#F18D13',
    700: '#FAA53D',
    800: '#FEC57B',
    900: '#FFE2BD',
    1000: '#FFF4E5',
  },
  red: {
    100: '#391813',
    200: '#601E16',
    300: '#AE2A19',
    400: '#CA3521',
    500: '#E34935',
    600: '#EF5C48',
    700: '#F87462',
    800: '#FF9C8F',
    900: '#FFD2CC',
    1000: '#FFEDEB',
  },
  purple: {
    100: '#120338',
    200: '#22075E',
    300: '#391085',
    400: '#531DAB',
    500: '#722ED1',
    600: '#9254DE',
    700: '#B37FEB',
    800: '#D3ADF7',
    900: '#EFDBFF',
    1000: '#F9F0FF',
  },
};

export default colorTokens;
